import axios from "axios";

const DATA_DOMAIN = import.meta.env.VITE_DATA_DOMAIN;

const BASE_URL = DATA_DOMAIN ? `https://${DATA_DOMAIN}/statuspage/v1` : `/api/statuspage/v1`;

export const dataFetcher = (path: string) =>
    axios.get(`${BASE_URL}${path}`).then((res) => res.data);
